__turbopack_context__.v({
  "add-on-text": "DsdjJa_add-on-text",
  "additionals-delimiter": "DsdjJa_additionals-delimiter",
  "checkbox-card": "DsdjJa_checkbox-card",
  "error-message": "DsdjJa_error-message",
  "form": "DsdjJa_form",
});
